import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import actionTypes from 'constants/currentUserConstants';

class AccountCreatedForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    currentUser: ImmutablePropTypes.map.isRequired,
    formValues: PropTypes.object.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  submitForm = event => {
    event.preventDefault();
    this.props.history.push('/checkout');
  };


  render() {
    const { formValues, currentUser, formIsLoading } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');

    return (
      <Card>
        <div className="card-header">
          <h4>Account created!</h4>
        </div>
        <CardBody>
          <p>
            We've created your account and sent a confirmation email to <strong>{formValues.email}</strong>!
          </p>
          <p>
            You'll be able to choose a password when you confirm your account.
          </p>
          <form onSubmit={this.submitForm}>
            <Button disabled={isLoading} block color="primary">
              {isLoading ? 'Please wait...' : 'Submit event!'}
            </Button>
          </form>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCreatedForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/AccountCreatedForm.jsx